import React from 'react';
import './styles.css'; // Import the styles.css file

const Banner = ({ onHomeClick, onModelGeneratorClick }) => {
  return (
    <div className="banner">
      <h1>Skill Director Competency Model Generator</h1>
      <div className="banner-buttons">
        <button onClick={onHomeClick}>Home</button>
        <button onClick={onModelGeneratorClick}>Model Generator</button>
      </div>
    </div>
  );
};

export default Banner;
